import * as Vue from 'vue'
import { defineAsyncComponent } from 'vue'
import { preFetchLib, bindVueRuntime } from 'hel-micro-wujie'
import { isClient } from '@vueuse/core'

bindVueRuntime({ Vue })

const loadRemoteComponents = ({
  libName,
  libUrl,
  libVersion,
  componentNames,
}: {
  libName: string
  libUrl: string
  libVersion: string
  componentNames: string[]
}) => {
  const components: Array<ReturnType<typeof defineAsyncComponent>> = []
  let lib: any = null

  if (!isClient) return components

  componentNames.forEach(n => {
    components.push(defineAsyncComponent(() => {
      return new Promise(async (resolve, reject) => {
        if (!lib) {
          try {
            lib = await preFetchLib(libName, {
              custom: {
                host: libUrl,
              },
              versionId: libVersion,
            })
          } catch(e) {
            reject('loadRemoteComponents: ' + e)
          }
        }
        resolve(lib[n])
      })
    }))
  })
  return components
}

const loadRemoteOthers = async ({
  libName,
  libUrl,
  libVersion,
  names,
}: {
  libName: string
  libUrl: string
  libVersion: string
  names: string[]
}) => {
  const others: any[] = []

  if (!isClient) return others

  const lib = await preFetchLib(libName, {
    custom: {
      host: libUrl,
    },
    versionId: libVersion,
  })
  names.forEach(n => {
    others.push(lib[n])
  })
  return others
}

export {
  loadRemoteComponents,
  loadRemoteOthers,
}
